import { h } from 'snabbdom';


import { Actions } from './actions';

/**
 * 
 * @param {import("./actions").Action} action 
 * @returns 
 */
export const actionView = (action)=>{
  return h('button',{
    class: {
      'notify-popup-button' : true,
      'notify-action-close': action.closeOnClick? true: false,
    },
  
    on: {click:() => {
      Actions[action.type](action.args);
      // todo: close the notification

    }}},
  `${action.title}`
  );
};

// const _toggleDetached = (notification) => {
    
// };

/**
 * 
 * @param {import ('./notification-item').NotificationStoreItem} notification 
 * @param {*} options 
 * @returns 
 */

export const itemDetailView = (notification,options ) => {
  
  
  return h('div.notify-wrap', [
    h(`div.notify-icon.${notification.type}`, [
      h(`i.bi.bi-${notification.icon}`)
    ]),
    h('div.notify-body', [
      h('div.notify-header', [
        h('p.notify-title', notification.title),
        h('span.notify-issue-date', options.useLocalTime? 
          `${notification.issueTime.toLocaleTimeString('en-us',{timeZoneName:'short',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute:'2-digit',})} `:
          notification.issueTime.toLocaleTimeString('en-us',{timeZoneName:'short',
            timeZone: 'UTC',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute:'2-digit',})),
        h('span.notify-author', `Author: ${notification.author}`)
  
      ]),
      notification.message !== ''?
        h('div.notify-message',  [
          h('p', {props :{innerHTML:notification.message}}),
        ]): '',
      h('div.notify-button-container', [
        ...notification.actions.map(actionView)
      ])
    ])        
  ]);
};


/**
 * 
 * @param {import ('./notification-item').NotificationStoreItem} notification 
 * @param {*} options 
 * @returns 
 */

export const itemView = (notification,options) => {
  
  const short = notification.message.split(' ').slice(0,35).join(' ');
  const shouldShowMore = notification.message.split(' ').length > 35 && notification.author!='System';
  
  return h('div.notify-wrap', [
    h(`div.notify-icon.${notification.type}`, [
      h(`i.bi.bi-${notification.icon}`)
    ]),
    h('div.notify-body', [
      h('div.notify-header', [
        h('p.notify-title', notification.title),
        h('span.notify-issue-date', options.useLocalTime? 
          `${notification.issueTime.toLocaleTimeString('en-us',{timeZoneName:'short',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute:'2-digit',})} `:
          notification.issueTime.toLocaleTimeString('en-us',{timeZoneName:'short',
            timeZone: 'UTC',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute:'2-digit',})),
        h('span.notify-author', notification.author !== 'System'?`Author: ${notification.author}`:'')
  
      ]),
      notification.message !== ''?
        h('div.notify-message',{ class:{'active':notification.active}},  [
          h('p', {props: 
            {innerHTML:
            (notification.active && options.toggleActive) || notification.author=='System' ? 
              notification.message :
              `${short}${shouldShowMore? '...': ''}`
            }
          }),
          
          (options.toggleActive|| notification.type   === 'error') && shouldShowMore ? h('span', {class:{'show-more':true},
            on:{
              click: () => {
                options.toggleActive(notification);
              }
            }
          },notification.active || notification.detached?'Show Less' : 'Show More'): ''
        
          
        ]): '',
      h('div.notify-button-container', [
        ...notification.actions.map(actionView)
      ])
    ])        
  ]);
};
